import { defaultMemberFormFieldPropsProvider } from '../../../../subcomponents/member-form-field/types/props';
export const defaultUpdateMemberDetailsFormFieldPropsProvider = props => {
    return defaultMemberFormFieldPropsProvider(props, 'UpdateMemberDetailsFormField');
};
//# sourceMappingURL=props.js.map